import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ReportManagementService } from '../report-management.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { AccountingService } from '../../accounting/accounting.service';

@Component({
  selector: 'app-manage-report',
  templateUrl: './manage-report.component.html',
  styleUrls: ['./manage-report.component.scss']
})
export class ManageReportComponent implements OnInit {
  isLoading: boolean;
  isEdit: boolean;
  reportForm: FormGroup;
  headerReportForm: FormGroup;
  reportStatus: boolean;
  measure;
  reportID: string;
  measureID: string;
  updateForm: FormGroup;
  free: boolean = false;
  paid: boolean = false;
  report;
  account: any;

  constructor(
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private reportManagementService: ReportManagementService,
    private gobalFunctionService: GobalFunctionService,
    private accountService: AccountingService
  ) { }

  ngOnInit(): void {
    this.isEdit = JSON.parse(new URL(location.href).searchParams.get('isEdit'));

    this.reportManagementService.getAllMeasureCanUse().pipe(
      switchMap(res => {
        // console.log(res);
        this.measure = res.result;

        return this.accountService.getActiveAccount().pipe(
          map(a => {
            // console.log(a.result);
            this.account = a.result;
          })
        )
      })
    ).subscribe();

    if (this.isEdit) {
      this.reportID = new URL(location.href).searchParams.get('report_id');
      this.gobalFunctionService.setTitle('แก้ไขรายงานผล');

      this.reportManagementService.getDetailReportById(this.reportID).pipe(
        map(res => {
          // console.log(res.result);
          this.report = res.result[0];

          this.headerReportForm = this.fb.group({
            name: [this.report.REPORT_NAME, Validators.required],
            measure_id: [this.report.MEASURE_ID, Validators.required],
            is_view: [this.report.IS_VIEW, Validators.required],
            accountId: [this.report.ACCOUNTING_ID, Validators.required],
          });

          this.updateForm = this.fb.group({
            des_free: [this.report.REPORT_DES_FREE],
            des_paid: [this.report.REPORT_DES_NOTFREE],
            price: [this.report.PRICE],
          })
          this.free = JSON.parse(this.report.STATUS_FREE);
          this.paid = JSON.parse(this.report.STATUS_NOTFREE);
          this.measureID = this.report.MEASURE_ID;
          // console.log(this.updateForm)
        })
      ).subscribe();

    } else if (!this.isEdit) {
      this.gobalFunctionService.setTitle('สร้างรายงานผล');

      this.headerReportForm = this.fb.group({
        name: ['', Validators.required],
        measure_id: ['', Validators.required],
        is_view: ['', Validators.required],
        accountId: ['', Validators.required],
      });

      this.updateForm = this.fb.group({
        des_free: [''],
        des_paid: [''],
        price: [''],
      })
    }

  }

  next(form) {
    // console.log(form);
    let body = {
      REPORT_NAME: form.name,
      MEASURE_ID: form.measure_id,
      IS_VIEW: form.is_view
    }
    this.isLoading = true;
    this.measureID = form.measure_id;

    this.reportManagementService.createReportTemplate(body).pipe(
      map(res => {
        if (res.success) {
          this.reportStatus = true;
          this.isLoading = false;
          this.reportID = res.result.REPORT_ID;
        }
      }),
      catchError((err) => {
        alert(err);
        return of(null);
      })
    ).subscribe();

  }

  changePage(report) {
    let body = {
      REPORT_ID: this.reportID,
      REPORT_NAME: this.headerReportForm.value.name,
      IS_VIEW: this.headerReportForm.value.is_view,
      STATUS_FREE: JSON.stringify(this.free),
      STATUS_NOTFREE: JSON.stringify(this.paid),
      REPORT_DES_FREE: this.updateForm.value.des_free,
      REPORT_DES_NOTFREE: this.updateForm.value.des_paid,
      PRICE: this.updateForm.value.price ? this.updateForm.value.price : 0,
      ACCOUNTING_ID: this.headerReportForm.value.accountId,
    }

    this.reportManagementService.updateReportTemplateById(body).pipe(
      map(res => {
        if (res) {
          if (report === 'free') {
            window.open('/report-management/report-template?isEdit=' + this.isEdit + '&report_id=' + this.reportID + '&isPaid=false&measure_id=' + this.measureID, '_self');
          } else if (report === 'notfree') {
            window.open('/report-management/report-template?isEdit=' + this.isEdit + '&report_id=' + this.reportID + '&isPaid=true&measure_id=' + this.measureID, '_self');
          }
        }
      }),
      catchError((err) => {
        alert(err.error.message);
        return of(null);
      })
    ).subscribe();

  }

  save(form) {
    this.isLoading = true;
    // console.log(form);
    let body = {
      REPORT_ID: this.reportID,
      REPORT_NAME: this.headerReportForm.value.name,
      IS_VIEW: this.headerReportForm.value.is_view,
      STATUS_FREE: JSON.stringify(this.free),
      STATUS_NOTFREE: JSON.stringify(this.paid),
      REPORT_DES_FREE: form.des_free,
      REPORT_DES_NOTFREE: form.des_paid,
      PRICE: form.price ? form.price : 0,
      ACCOUNTING_ID: this.headerReportForm.value.accountId,
    }
    // console.log(body);
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.autoFocus = false;
    dialogConfig.width = '350px';

    dialogConfig.data = {
      title: 'บันทึกรายงานผล',
      actionBtnText: 'บันทึก',
      cancleBtnText: 'ยกเลิก',
      description: `ต้องการบันทึกข้อมูลรายงานผลใช่หรือไม่ ?`
    }
    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    modal.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          return this.reportManagementService.updateReportTemplateById(body).pipe(
            switchMap(res => {
              if (res) {
                // console.log(res);
                this.isLoading = false;
                const dialogConfig1 = new MatDialogConfig();
                dialogConfig1.disableClose = true;
                dialogConfig1.id = 'modalConfirm';
                dialogConfig1.width = '350px';
                dialogConfig1.data = {
                  title: 'บันทึกสำเร็จ',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                  <h5>บันทึกสำเร็จ</h5>`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal = this.matDialog.open(ModalComponent, dialogConfig1);
                return modal.afterClosed().pipe(
                  map(res => {
                    if (!res) {
                      // console.log(res);
                    }
                  })
                )
              } else {
                // console.log(res);
                alert(res);
                return of(null);
              }
            })
          )
        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError((err) => {
        alert(err.error.message);
        return of(null);
      })
    ).subscribe();
  }

  changeStatus(type, check) {
    if (type === 'free' && !check) {
      this.updateForm.patchValue({
        des_free: ''
      });
      this.updateForm.get('des_free').updateValueAndValidity();

    } else if (type === 'paid' && !check) {
      this.updateForm.patchValue({
        des_paid: '',
        price: ''
      });
      this.updateForm.get('des_paid').updateValueAndValidity();
      this.updateForm.get('price').updateValueAndValidity();
    }
  }


}
